import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useCommonNode from '../_COMMON/useCommonNode.jsx'
import IconAvatar from '../icons/IconAvatar.jsx'
import meta from './metaRole.mjs'

export default () => {
    const CommonNode = useCommonNode()

    return extendNode(CommonNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(CAT|COPR)$/.test(type)
        },

        getIcons() {
            return [
                <IconAvatar
                    key="type"
                    color={Color.BLUE}
                />
            ]
        },

        getStyle(map, node) {
            return {
                ...CommonNode.getStyle.call(this, map, node),
                borderColor: Color.GOLD,
            }
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'COPR'},
            ]
        },

        _fixChild(map, node, child) {
            const {bizNodeType} = child.data

            if ('FOPR' === bizNodeType) {
                map.BizNode.COPR.castFrom(map, child)
                return true
            }
            else {
                return CommonNode._fixChild.call(this, map, node, child)
            }
        },
    })
}
